import { render, staticRenderFns } from "./SearchBarResultsItem.vue?vue&type=template&id=056e14a2&scoped=true&"
import script from "./SearchBarResultsItem.vue?vue&type=script&lang=js&"
export * from "./SearchBarResultsItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarResultsItem.vue?vue&type=style&index=0&id=056e14a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e14a2",
  null
  
)

export default component.exports